// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 筛选器配置
const filterItemsConfig = {
    scopedSlots: {
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon'
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '订单编号',
    dataIndex: 'number',
    key: 'number',
    width: 180,
    ...columnPublicConfig,
},
{
    title: '客户名称',
    dataIndex: 'clientname',
    filterIndex: 'clientname',
    key: 'clientname',
    type: 'input',
    ...columnPublicConfig,
    ...filterItemsConfig
},
// {
//     title: '所属区域',
//     dataIndex: 'arsename',
//     filterIndex: 'area_id',
//     key: 'arsename',
//     type: 'select',
//     items: [],
//     ...columnPublicConfig,
//     ...filterItemsConfig
// },
{
    title: '总重量',
    dataIndex: 'sumweight',
    key: 'sumweight',
    ...columnPublicConfig
},
{
    title: '总价',
    dataIndex: 'summoney',
    key: 'summoney',
    ...columnPublicConfig
},
{
    title: '实付金额',
    dataIndex: 'paymoney',
    key: 'paymoney',
    scopedSlots: {
        customRender: 'c-money'
    },
    ...columnPublicConfig
},
{
    title: '是否支付',
    dataIndex: 'is_pay',
    filterIndex: 'is_pay',
    key: 'is_pay',
    type: 'select',
    items: [{
        id: 1,
        name: '是'
    }, {
        id: 2,
        name: '否'
    }],
    scopedSlots: {
        customRender: 'c-type',
        ...filterItemsConfig.scopedSlots
    },
    ...columnPublicConfig
},
{
    title: '支付方式',
    dataIndex: 'payname',
    filterIndex: 'pay',
    key: 'payname',
    type: 'select',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '订单状态',
    dataIndex: 'single_type',
    key: 'single_type',
    ...columnPublicConfig,
},
{
    title: '气站名称',
    dataIndex: 'forshort',
    key: 'forshort',
    ...columnPublicConfig,
},
{
    title: '修改时间',
    dataIndex: 'updated_at',
    filterIndex: 'time',
    key: 'updated_at',
    type: 'range',
    items: [],
    ...columnPublicConfig,
    ...filterItemsConfig
},
{
    title: '订单详情',
    dataIndex: 'goods',
    filterIndex: "is_type",
    key: 'goods',
    type: "select",
    items: [
        {
            id: 1,
            name: '正常',
        },
        {
            id: 2,
            name: '销账',
        },
        {
            id: 3,
            name: '作废',
        },
    ],
    ...columnPublicConfig,
    scopedSlots: {
        customRender: 'c-detail',
        ...filterItemsConfig.scopedSlots
    },
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 180,
    ...columnPublicConfig,
    scopedSlots: {
        customRender: 'c-action'
    }
}]
